export default "__VITE_ASSET__oSivy9F1__"